export const PASSWORD = "password";
export const STRONG_PASSWORD = "strong-password";
export const EMAIL = "email";
export const PHONE_NUMBER = "phoneNumber";
export const DATE = "date";
export const ETOS = "etos";
export const URL = "url";
